import Alert from '@components/alert/Alert';

const AlertError = ({ error }) => (
	<Alert variant="danger" heading="Error">
		<p>{error}</p>
	</Alert>
);
export default AlertError;
